import { updateTenderDefinition } from "@snubes/snubes-types";
import { getCallable } from "../../Firebase/helpers/getCallable";

export const updateTenderCallable = getCallable(updateTenderDefinition);
